module.exports = __webpack_public_path__ + "files/87e4f4318dc840b4e08a227ecdd7ad24.png";